<template>
    <div></div>
</template>
<script>
import axios from 'axios'
export default {
    name:'ItemsMercaderiaExcel',
    props:['item','action','itemsEx'],
    data() {
        return {
            preitem: {},
            items:[],
            igvGlobal:'',
            unoDieciocho:1.18,
            ceroDieciocho:0.18,
            dieciocho:18,
            unoUno:1.105,
            ceroUno:0.105,
            diez:10.5,
        }
    },
    mounted() {
        this.getSeriesIGV()
        this.initPreItem()
    },
    watch: {
        'action.i': function () {
                if(this.action.i){   
                    for( let i = 0; i<this.itemsEx.length; i++){ 
                        this.completeItem(i)
                    }
                }          
            },
        'action.reset': function () {
                if(this.action.reset){
                    this.items = []
                }   
            }    
    },
    methods: {
        getSeriesIGV(){
        axios
        .post(process.env.VUE_APP_API_URL + "usuario/series/" + 1, {
          token: this.$store.getters.userToken
        })
        .then(response => (
          this.igvGlobal = response.data.igv
        ))
        },
        initPreItem(){
            this.preitem = {
                idProducto:'',
                codigo:'',
                descripcion:'',
                unidadMedida:'',
                cantidad:'',
                precioUnitario:'',
                igv:'',
                valorTotal:'',
                valorUnitario: '',
                precioTotal:'',
                tipoAfectacionIgv:'',
                precioVentaUnitario:'',
                codigoProductoGs1:'',
                codigoProductoSunat:'',
                idCategoria:'',

            }   
        },
        completeItem(i){
            if(this.itemsEx){
                this.preitem.cantidad = parseFloat(this.itemsEx[i].cantidad)
                this.preitem.unidadMedida = this.itemsEx[i].unidadMedida
                this.preitem.codigo = this.itemsEx[i].codigo.toString()
                this.preitem.descripcion = this.itemsEx[i].descripcion
                this.preitem.precioUnitario = this.itemsEx[i].precioUnitario
                this.preitem.precioVentaUnitario = this.itemsEx[i].precioUnitario
                this.preitem.idProducto = this.itemsEx[i].idProducto
                this.preitem.codigoProductoGs1 = this.itemsEx[i].codigoProductoGs1
                this.preitem.codigoProductoSunat = this.itemsEx[i].codigoProductoSunat
                this.preitem.idCategoria = this.itemsEx[i].idCategoria
                if(this.itemsEx[i].tipoAfectacionIgv == '01'){
                    this.preitem.valorTotal = ((this.preitem.cantidad * this.preitem.precioUnitario) / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(5)
                    this.preitem.igv = (this.preitem.valorTotal * (this.$store.state.igv == 18 ? 0.18 : 0.105)).toFixed(5)
                    this.preitem.valorUnitario = (this.preitem.precioUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(5)
                    this.preitem.precioTotal = this.preitem.cantidad * this.preitem.precioUnitario
                    this.preitem.tipoAfectacionIgv = '01'
                }else if(this.itemsEx[i].tipoAfectacionIgv == '02'){
                    this.preitem.valorTotal = this.preitem.cantidad * this.preitem.precioUnitario
                    this.preitem.igv = parseFloat(0.0)
                    this.preitem.valorUnitario = this.preitem.precioUnitario
                    this.preitem.precioTotal = this.preitem.precioUnitario
                    this.preitem.tipoAfectacionIgv = '02'
                }else if(this.itemsEx[i].tipoAfectacionIgv == '03'){
                    this.preitem.valorTotal = this.preitem.cantidad * this.preitem.precioUnitario
                    this.preitem.igv = parseFloat(0.0)
                    this.preitem.valorUnitario = this.preitem.precioUnitario
                    this.preitem.precioTotal = this.preitem.precioUnitario
                    this.preitem.tipoAfectacionIgv = '03'
                }
                this.items.unshift(this.preitem)
                this.initPreItem()
                this.getItems(this.items)
            }
        },
        getItems(data){
            this.$emit("totalitems",data)
        }
    },
}
</script>